export function clamp(v, min, max) {
    return v < min ? min : v > max ? max : v
}

export function rgbToHsv(r, g, b) {
    const rr = r / 255
    const gg = g / 255
    const bb = b / 255
    const max = Math.max(rr, gg, bb)
    const min = Math.min(rr, gg, bb)
    const d = max - min
    let h = 0
    if (d !== 0) {
        if (max === rr) h = ((gg - bb) / d) % 6
        else if (max === gg) h = (bb - rr) / d + 2
        else h = (rr - gg) / d + 4
        h *= 60
        if (h < 0) h += 360
    }
    const s = max === 0 ? 0 : d / max
    return [h, s, max]
}

export function hsvToRgb(h, s, v) {
    const c = v * s
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
    const m = v - c
    let rr = 0
    let gg = 0
    let bb = 0
    if (h < 60) [rr, gg, bb] = [c, x, 0]
    else if (h < 120) [rr, gg, bb] = [x, c, 0]
    else if (h < 180) [rr, gg, bb] = [0, c, x]
    else if (h < 240) [rr, gg, bb] = [0, x, c]
    else if (h < 300) [rr, gg, bb] = [x, 0, c]
    else [rr, gg, bb] = [c, 0, x]
    return [
        Math.round((rr + m) * 255),
        Math.round((gg + m) * 255),
        Math.round((bb + m) * 255),
    ]
}

export function hueDistance(a, b) {
    const d = Math.abs(a - b) % 360
    return d > 180 ? 360 - d : d
}

export function rgbToHex(rgb) {
    return (
        '#' +
        rgb
            .map((v) => clamp(Math.round(v), 0, 255).toString(16).padStart(2, '0'))
            .join('')
    )
}

const HUE_NAMES = [
    [15, 'Red'],
    [45, 'Orange'],
    [70, 'Yellow'],
    [160, 'Green'],
    [200, 'Cyan'],
    [255, 'Blue'],
    [290, 'Purple'],
    [330, 'Magenta'],
    [360, 'Red'],
]

export function colourName(h, s, v) {
    if (v < 0.15) return 'Black'
    if (s < 0.18) return v > 0.75 ? 'White' : 'Gray'
    for (const [limit, name] of HUE_NAMES) {
        if (h < limit) return name
    }
    return 'Red'
}
